import { Theme, CSSObject } from '@mui/material/styles'

export const openedMixin =
  (openWidth: number) =>
  (theme: Theme): CSSObject => ({
    width: openWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  })

export const closedMixin =
  (closedWidth: number) =>
  (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: closedWidth,
    [theme.breakpoints.up('sm')]: {
      width: closedWidth,
    },
  })
